import {
  Ability,
  AbilityBuilder,
  ForcedSubject,
  MongoQuery,
  subject
} from '@casl/ability'
import { ACTIONS, SUBJECTS } from './constants'

export type DashboardAbilityDataType = {
  uuid: string
  outside_community?: boolean | null
}

export type Actions = ValueOfObject<typeof ACTIONS>
export type Subjects = ValueOfObject<typeof SUBJECTS>

export type PossibleAbilities = [
  Actions,
  Subjects | (DashboardAbilityDataType & ForcedSubject<Subjects>)
]

export type Conditions =
  | Record<PropertyKey, number | string | MongoQuery>
  | MongoQuery<Record<PropertyKey, number | string | MongoQuery>>

export type DashboardAbility = Ability<PossibleAbilities, Conditions>

export type DashboardAbilityBuilder = AbilityBuilder<DashboardAbility>

export const dashboardSubject = (type, object) =>
  subject<Subjects, DashboardAbilityDataType>(type, { ...object })
